import { useCallback } from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import { useSportsMyBetsWidget } from '../../../../../../../model';
import type { CashoutBetRequest, UnsuccessfulCashoutBetResponse } from '../types';
import getTranslationForResponseStatus from '../utils/getTranslationForResponseStatus';

import { TXTWCL_SorryX_something_went_wrongX_P_ELL } from './useCashOut.messages.json';
import useRequestCashOut from './useRequestCashOut';

const useCashOut = () => {
  const { widgetDispatch } = useSportsMyBetsWidget();
  const { formatMessage } = useRegulatoryIntl();
  const requestCashOut = useRequestCashOut();

  const cashOut = useCallback(
    async (
      cashOutBetRequest: CashoutBetRequest,
      trackCashOutError: (responseStatus?: UnsuccessfulCashoutBetResponse['respStatus']) => void
    ) => {
      const betId = cashOutBetRequest.betId.toString();
      try {
        widgetDispatch.cashOutSubmit({ betId });

        const { body: response } = await requestCashOut(cashOutBetRequest);

        if (response.respStatus === 'SUCCESS') {
          widgetDispatch.cashedOutSuccessfully({
            betId,
            cashedOutAmount: response.cashedOutQuote
          });
        } else {
          widgetDispatch.cashOutQuotesRequested();
          trackCashOutError(response.respStatus);
          widgetDispatch.cashOutFailure({
            cashOutError: formatMessage(getTranslationForResponseStatus(response.respStatus)),
            betId
          });
        }
      } catch {
        widgetDispatch.cashOutQuotesRequested();
        trackCashOutError();
        widgetDispatch.cashOutFailure({
          cashOutError: formatMessage(TXTWCL_SorryX_something_went_wrongX_P_ELL),
          betId
        });
      }
    },
    [requestCashOut, widgetDispatch, formatMessage]
  );

  return { cashOut };
};

export default useCashOut;
